import type { Theme } from "../theme/ThemeProvider";

// Chart palette helpers — ported verbatim from platform.html so the chart
// look matches in both light and dark themes.

export function gridColor(theme: Theme): string {
  return theme === "light" ? "#E3DFD9" : "rgba(255,255,255,0.07)";
}

export function tickColor(_theme: Theme): string {
  // Original uses #6A6359 in both themes for the tick text.
  return "#6A6359";
}

export function legendColor(theme: Theme): string {
  return theme === "light" ? "#5A5450" : "#A39C91";
}
